import './actionsColumn.less'

import {observer} from "mobx-react";
import React from "react";

import {GridDataEntry} from "controls/grid/gridDataEntry";
import {GridSelection, GridSelectionMode} from "controls/grid/gridSelection";
import {GridStore} from "controls/grid/gridStore";
import {GridMenuPlugin} from "controls/grid/plugins/grid-menu/gridMenuPlugin";
import {GridDataItem} from "controls/grid/gridDataItem";
import {AntButton} from "controls/react/ant/antButton";

export type ActionsColumnsProps<DataEntry extends GridDataEntry> = {
	store: GridStore<DataEntry>
	item: GridDataItem<DataEntry>
}

const b = require('b_').with('grid-action-column')

export const InlineActionsColumn = observer(<DataItem extends GridDataEntry>(props: ActionsColumnsProps<DataItem>) => {
	const plugin = props.store.plugins
		.find(x => x.id == 'grid-menu') as GridMenuPlugin<DataItem>

	const gridSelection = new GridSelection(plugin.store)
	gridSelection.ids.push(props.item.id)

	const items = plugin.getActionsForSelection(gridSelection, plugin.config.inlineActionsColumn)

	return <>
		{items.map(x => {
			if('type' in x){
				return ''
			}
			return <AntButton type={"text"}
							  key={x.id}
			                  title={x.label}
			                  icon={x.icon}
			                  onClick={() => plugin.invokeAction(x, gridSelection)}/>
		})}
	</>
})
